module.exports = __webpack_public_path__ + "static/logoW-ea065e3968e10600c68d4910207f3cd1.svg";